import SharingNewsfeedItem from "../react_components/newsfeed/sharing/sharing_newsfeed_item";
import CommentsStore from "../react_stores/comments_store";
import LikeStore from "../react_stores/like_store";
import ShelvingsStore from "../react_stores/shelvings_store";
import UserShelvesStore from "../react_stores/user_shelves_store";

export const SharingShowComponents = {
  SharingNewsfeedItem,
};

export const SharingShowStores = {
  CommentsStore,
  LikeStore,
  ShelvingsStore,
  UserShelvesStore,
};
